import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ObjetivoService } from '../../services/objetivo.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { ModalService } from 'src/app/services/modal.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../services/participante.elemento.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from "primeng/api";
import { UnidadesSiipneService } from 'src/app/services/unidades-siipne.service';
import { EstrategiaObjetivoService } from '../../services/estrategia-objetivo.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { AniosObjetivosService } from 'src/app/modulos/catalogos-admin/services/anios-objetivos.service';
import { ActividadesService } from '../../services/actividades.service';
import { PlanAccionService } from '../../services/plan.accion.service';
import { RiesgosService } from '../../services/riesgos.service';
import { planesAccionInterface } from '../../models/plan.accion';

@Component({
  selector: 'app-plan-accion',
  templateUrl: './plan-accion.component.html',
  styleUrls: ['./plan-accion.component.css'],
})
export class PlanAccionComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Formulación Planes' },
    { label: 'Elementos' },
    { label: 'Planes de Acción', active: true },
  ];
  public formPlanAccion: UntypedFormGroup;
  public submitted = false;
  public dataPlanAccionObjetivos: any = [];
  public dataObjetivo: any = [];
  public dataPlanAccion: any[] = [];
  private idDeleteRegister: number = 0;
  private ipAddress!: string;
  public idSprNivel: number = 0;
  public estadoActivo: number = 1; //traer los que estan en estado activo 

  public selectItems: any = [];
  private idSprAmbiente: number = 0;
  private idSprUsuario: number = 0;

  public nombreObjetivos = [];
  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;

  public objetivo: any = null;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @ViewChild('modalChild') myModal: any;
  public dataEstrategiaObjetivo!: any;
  public nameApp: string = 'PLANES DE ACCIÓN PARA OBJETIVOS';
  public nameModal: string = 'modalPlanAccion';
  public modalActividad: string = 'modalActividadesPlanes'
  tituloActividad = 'ACTIVIDADES';
  public dataEstrategiaL: any = [];
  unidades: TreeNode[];
  selectedFile: TreeNode;
  public nombreRuta: any = '';
  public dataParticipantesElemento!: any;
  public dataTipoPlanAccion!: any;
  public outDataPlanAccion: any;
  public idPlanAccion: any;
  public participanteElementoAeliminar = [];
  public dataPersonalElementoL!: any;
  public dataEquipoGerencialL!: any;
  public dataPlanAccionEquipo!: any;
  public participanteElemento: any = [];
  inputsAnteriores = [];
  public patrocinadorOriginal: any;
  public guardarEquipoGerencialSeleccionado: any;
  public idSprParticipanteElementoM!: any;
  public idSprAnio: number = 0;
  public idSprPlanAnio: number = 0;

   //Almacena el usuario actual disponible en Redux
  currentUserRedux: UsuarioRedux = null;

  
  public dataPlanesAnios: any = [];
  public idSprParticipanteElemento: number = 0;
  public dataRiesgos!: any;
  public idSprUsuarioApp:any;
  public dataActividades!: any;
  readonly constant = ConstantsCatalogosIdService;
  public idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_PARTICIPANTE;
  public idEquipoPlanAccion = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_PLAN_ACCION;
  public idTipoPlanAccion = ConstantsCatalogosIdService.ID_COMUNES_TIPO_LINEA_PLAN_DE_ACCION;



  constructor(
    public estrategiaObjetivoService: EstrategiaObjetivoService,
    private unidadesSiipneService: UnidadesSiipneService,
    private alertService: AlertService,
    public modal: ModalService,
    private planAccionService: PlanAccionService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private objetivoService: ObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private equipoLineasAccionService: EquipoGerencialService,
    private equipoGerencialService: EquipoGerencialService,
    public store: Store<AppState>,
    private planAniosService: AniosObjetivosService,
    private actividadesService: ActividadesService,
    private riesgosService: RiesgosService,
  ) {

    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response) => {// redux
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.initApp();
    });

    this.store.select("usuarioApp").subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuarioApp = response.currentUser.idSprUsuario;
    });
  }

  initApp() {
    this.listRiesgos();
    this.listActividades();
    this.getIpPublic();
    this.setDataTable();
    this.setFormPlanAccion();
    this.getDataParticipantes();
    this.listTipoPlanAccion();
    this.getTreeUnidadesSiipne();
    this.listPlanAnios();
  }

  setFormPlanAccion(dataRowObjetivo: any = []) {
    let idSprObjetivo = dataRowObjetivo.idSprObjetivo
    this.fechaIniciObjetivo = dataRowObjetivo.fechaInicioObjetivo
    this.fechaFinObjetivo = dataRowObjetivo.fechaFinObjetivo
    this.formPlanAccion = this.fb.group({
      idSprObjetivo: [idSprObjetivo],
      idSprPlanAccion: [],
      idSprTipoPlanAccion: [],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      fechaFin: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      objetivoGeneral: ['', [Validators.required]],
      objetivoEspecifico: ['', [Validators.required]],
      estado: ['', [Validators.required]],
      idSprEquipoGerencial: ['', [Validators.required]],
      /**set localidad de impacto **/
      localidadImpacto: ['', [Validators.required]],//para la localidad de impacto
      idDgpUnidad: [],//para la localidad de impacto
      /* Fin set localidad de impacto */
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  listPlanAnios() {
    this.planAniosService.list('?idSprAnio=' + this.idSprAnio).subscribe({
      next: (resp) => {
        this.dataPlanesAnios = resp;
        this.idSprPlanAnio = resp[0].idSprPlanAnio;
        this.getDataAll(this.idSprPlanAnio);
      }
    })
  }

  getDataAll(idSprPlanAnioSelected: number) {
    forkJoin([
      this.objetivoService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + idSprPlanAnioSelected + '&estado=' + this.estadoActivo),
      this.planAccionService.list(),
    ]).pipe(map(
      ([dataObjetivo, dataPlanAccion]) => {
        this.dataObjetivo = dataObjetivo;
        this.dataPlanAccion = dataPlanAccion;
        this.mapDataLineasObjetivos();
      })).subscribe();
  }


  mapDataLineasObjetivos() {
    this.dataPlanAccionObjetivos = []
    let indiceUno = 0;
    let dataProcess: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataPlanAccion.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataPlanAccion[j].idSprObjetivo) {
          dataProcess.push({
            idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
            nombreObjetivo: this.dataObjetivo[i].nombre,
            idSprPlanAccion: this.dataPlanAccion[j].idSprPlanAccion,
            nombrePlanAccion: this.dataPlanAccion[j].nombre,
            descripcion: this.dataPlanAccion[j].descripcion,
            objetivoGeneral: this.dataPlanAccion[j].objetivoGeneral,
            objetivoEspecifico: this.dataPlanAccion[j].objetivoEspecifico,
            idSprTipoPlanAccion: this.dataPlanAccion[j].idSprTipoPlanAccion,
            idSprT: this.dataPlanAccion[j].idSprT,
            fechaInicio: this.dataPlanAccion[j].fechaInicio,
            fechaFin: this.dataPlanAccion[j].fechaFin,
            estado: this.dataPlanAccion[j].estado,
            localidadImpacto: this.dataPlanAccion[j].localidadImpacto,
            nombreElemento: this.nameModal,
          }); indiceUno++;
        }
      }
      this.dataPlanAccionObjetivos.push({
        nombreObjetivo: this.dataObjetivo[i].nombre,
        idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
        fechaInicioObjetivo: this.dataObjetivo[i].fechaInicio,
        fechaFinObjetivo: this.dataObjetivo[i].fechaFin,
        planAccion: dataProcess
      }); dataProcess = [];
    }
  }

  getDataParticipantes() {
    this.equipoLineasAccionService.list(
      `?idSprAmbiente=${this.idSprAmbiente}&idSprTipoParticipante=${this.idEquipoPlanAccion}&estado=${1}`)
      .subscribe(
        (resp) => {
          this.dataParticipantesElemento = resp
        });
  }

  listTipoPlanAccion(){ //trae los tipo de plan  de accion de los catalogos comunes
    this.comunService.list("?spr_idSprComun=" + this.idTipoPlanAccion)
      .subscribe(resp => {
        this.dataTipoPlanAccion = resp;
      })
  }

  onSubmit() {
    this.submitted = true;
    this.formPlanAccion.value.idSprAmbiente = this.idSprAmbiente;
    this.formPlanAccion.value.usuario = this.idSprUsuarioApp;
    this.formPlanAccion.value.ip = this.ipAddress;
    
    let fechaInicial = this.formPlanAccion.value.fechaInicio;
    let fechaFinal = this.formPlanAccion.value.fechaFin;
    if (fechaInicial > fechaFinal) {
      this.alertService.warning(
        '!Atención!',
        'La fecha inicial no puede ser mayor a la fecha final'
      );
      return;
    }
    //Realizar el posteo
    let planAccion = {
      idSprAmbiente: this.idSprAmbiente,
      usuario: this.idSprUsuario,
      ip: this.ipAddress,
      idSprObjetivo: this.formPlanAccion.value.idSprObjetivo,
      idSprTipoPlanAccion: this.formPlanAccion.value.idSprTipoPlanAccion,
      idSprPlanAccion: this.formPlanAccion.value.idSprPlanAccion,
      nombre: this.formPlanAccion.value.nombre,
      descripcion: this.formPlanAccion.value.descripcion,
      fechaInicio: this.formPlanAccion.value.fechaInicio,
      fechaFin: this.formPlanAccion.value.fechaFin,
      objetivoGeneral: this.formPlanAccion.value.objetivoGeneral,
      objetivoEspecifico: this.formPlanAccion.value.objetivoEspecifico,
      localidadImpacto: this.formPlanAccion.value.localidadImpacto,
      impactoProceso: 0, // verificar
      estado: this.formPlanAccion.value.estado,
      idSprEquipoGerencial: this.formPlanAccion.value.idSprEquipoGerencial,
    };
    let participantePlanAccion = {
      idSprObjetivo: this.formPlanAccion.value.idSprObjetivo,
      idSprParticipanteElemento: this.formPlanAccion.value.idSprParticipanteElemento,
      idSprEquipoGerencial: this.formPlanAccion.value.idSprEquipoGerencial,
      idSprPlanAccion: this.formPlanAccion.value.idSprPlanAccion,
      fechaInicio: this.formPlanAccion.value.fechaInicio,
      fechaFin: this.formPlanAccion.value.fechaFin,
      estado: 1,
      ip: this.ipAddress,
      usuario: this.idSprUsuario,
    };
    if (this.formPlanAccion.valid) {
      if (planAccion.idSprPlanAccion === null) {
        this.formPlanAccion.value.fechaInicio = fechaInicial;
        this.formPlanAccion.value.fechaFin = fechaFinal;
        this.planAccionService.create(planAccion)
          .pipe(
            mergeMap((planAccionGuardado) => {
              let suscribciones = [];
              planAccion.idSprPlanAccion = planAccionGuardado.idSprPlanAccion;
              participantePlanAccion.idSprPlanAccion = planAccionGuardado.idSprPlanAccion;
              suscribciones.push(
                this.participanteElementoService.create(participantePlanAccion)
              );
              return forkJoin(suscribciones);
            })
          )
          .subscribe(
            (data) => {
              this.alertService.createOk();
              this.closeModal();
              this.initApp()
            },
            (err) => {
              this.alertService.createError();
              this.planAccionService.delete(planAccion).subscribe();
              this.closeModal();
            }
          );
      } else {
        let participanteElemento
        this.participanteElementoService.list(`?idSprPlanAccion=${planAccion.idSprPlanAccion}`).subscribe(respParticpaElemento => {
          respParticpaElemento.forEach(
            respuesta => {
              if (respuesta.estado === 1) {
                this.idSprParticipanteElementoM = respuesta.idSprParticipanteElemento
              }
            }
          )
        }
        )
        participanteElemento = {
          idSprParticipanteElemento: this.idSprParticipanteElemento,
          idSprEquipoGerencial: this.formPlanAccion.value.idSprEquipoGerencial,
          idSprPlanAccion: this.formPlanAccion.value.idSprPlanAccion,
          fechaInicio: this.formPlanAccion.value.fechaInicio,
          fechaFin: this.formPlanAccion.value.fechaFin,
          estado: 1,
          ip: this.ipAddress,
          usuario: this.idSprUsuario,
        };
        this.participanteElementoService.update(participanteElemento).subscribe()
        this.planAccionService.update(planAccion).subscribe(data => {
          this.alertService.createOk();
          this.onResetForm();
          this.closeModal();
          this.initApp();
        }, (err) => {
          this.alertService.createError();
          this.planAccionService.delete(planAccion).subscribe();
          this.closeModal();
        });
      }
    } else {
      return;
    }
  }
  updatePlanAccion(obj: any, rowDataObjetivo) {
    this.onResetForm();
    this.nombreObjetivos = obj.nombreObjetivo;
    this.setFormPlanAccion(rowDataObjetivo)
    this.getDataParticipanteElemento(obj.idSprPlanAccion)
    this.formPlanAccion.patchValue({
      idSprObjetivo: obj.idSprObjetivo,
      idSprPlanAccion: obj.idSprPlanAccion,
      nombre: obj.nombrePlanAccion,
      descripcion: obj.descripcion,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      objetivoGeneral: obj.objetivoGeneral,
      objetivoEspecifico: obj.objetivoEspecifico,
      localidadImpacto: obj.localidadImpacto,
      impactoProceso: 0, // verificar
      estado: obj.estado,
      idSprAreaElemento: obj.idSprAreaElemento,
      idSprTipoPlanAccion: obj.idSprTipoPlanAccion
    });
    this.modal.open(this.nameModal);
  }
  getDataParticipanteElemento(idSprPlanAccion: number) {
    this.participanteElementoService.list('?idSprPlanAccion=' + idSprPlanAccion)
      .subscribe((res: any) => {
        this.participanteElemento = res
        let participanteElementoPatrocinador: any
        this.inputsAnteriores = []
        res.forEach(participante => {
          this.equipoGerencialService.getById(participante.idSprEquipoGerencial).subscribe((resi: any) => {

            this.patrocinadorOriginal = participante
            participanteElementoPatrocinador = resi
            this.guardarEquipoGerencialSeleccionado = resi
            this.formPlanAccion.patchValue({
              ...this.formPlanAccion.value,
              idSprEquipoGerencial: resi.idSprEquipoGerencial,
              idSprParticipanteElemento: participante.idSprParticipanteElemento
            })
            this.formPlanAccion.value.idSprEquipoGerencial = resi.idSprEquipoGerencial
            this.formPlanAccion.value.idSprParticipanteElemento = participante.idSprParticipanteElemento
            this.idSprParticipanteElemento = participante.idSprParticipanteElemento;
          })
        })
      })
  }
  delete(row: any) {
    this.idDeleteRegister = row.idSprPlanAccion;
    this.modal.open('delete-objetivo');
  }
  async confirmDelete() {
    let errorDeleteState: boolean = false;
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    let participantesElementos = [];
    dataVerifyRelacion = await this.verifyActividades();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    let dataDeleteParticipElementos = {
      usuario: this.idSprUsuarioApp,
      idSprParticipanteElemento: 0,
      ip: this.ipAddress,
      delLog: 'S'
    };
    let dataDeletePlanAccion = {
      idSprPlanAccion: this.idDeleteRegister,
      usuario: this.idSprUsuario,
      ip: this.ipAddress,
      delLog: 'S'
    }
    if (confirmDelete) {
      this.actividadesService.list(`?idSprPlanAccion=${this.idDeleteRegister}&delLog=N`)
      this.participanteElementoService.list(`?idSprPlanAccion=${this.idDeleteRegister}`).subscribe(response => {
        participantesElementos = response;
        participantesElementos.forEach(itemParticipanteElement => {
          dataDeleteParticipElementos.idSprParticipanteElemento = itemParticipanteElement.idSprParticipanteElemento;
          this.participanteElementoService.delete(dataDeleteParticipElementos).subscribe({
            next: responseDelete => {
              this.planAccionService.delete(dataDeletePlanAccion).subscribe({
                next: responseDelete => {
                },
                error: (error) => {
                  errorDeleteState = true;
                }
              })
            },
            error: (error) => {
              errorDeleteState = true;
              dataDeletePlanAccion.delLog = 'N';
              this.planAccionService.delete(dataDeletePlanAccion).subscribe({
                next: responseDelete => {
                },
                error: (error) => {
                  errorDeleteState = true;
                }
              })
            }
          })
        });
        this.participanteElementoService.list("?idSprLineAccion" + this.idDeleteRegister).subscribe(
          res => {
            res.forEach(participantesElemento => {
              this.participanteElementoService.delete(participantesElemento).subscribe()
            })
          }
        )
      });
      if (!errorDeleteState) {
        this.planAccionService.delete(dataDeletePlanAccion).subscribe({
          next: responseDelete => {
          },
          error: (error) => {
            errorDeleteState = true;
          }
        })
      }
      if (!errorDeleteState) {
        this.modal.close();
        this.alert.deleteOk();
        this.initApp()
      } else {
        this.alert.deleteError();
      }
    } else {
      this.alert.alertActividades();
      this.modal.close();
    }
  }

  verifyActividades() {
    return this.actividadesService.list(`?idSprPlanAccion=${this.idDeleteRegister}&delLog=N`).toPromise();
  }

  modalActividades(obj: planesAccionInterface) {
    this.outDataPlanAccion = obj;
    this.modal.open(this.modalActividad);
    this.formPlanAccion.patchValue({
      idSprPlanAccion: obj.idSprPlanAccion,
    });
    this.idPlanAccion = obj.idSprPlanAccion;
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onResetForm() {
    this.submitted = false;
    this.formPlanAccion.reset();
  }

  openModal(row: any) {
    this.limpiarLocalidadImpacto();
    this.onResetForm();
    this.setFormPlanAccion(row);
    this.nombreObjetivos = row.nombreObjetivo;
    this.modal.open(this.nameModal);

    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);
  }


  closeModal() {
    this.modal.close();
    this.setDataTable()
  }
  closeModalPlanesAccion() {
    this.modal.close();
   this.limpiarLocalidadImpacto()
  }
  limpiarLocalidadImpacto(){
    const miTextArea = document.getElementById('localidadImpacto') as HTMLTextAreaElement;
    miTextArea.value = "";
    this.nombreRuta="";
  }

  closeModalActividad(modalActividad: any) {
    this.modal.closeId(modalActividad);
    this.initApp();
    this.setDataTable()
  }


  get appForm() {
    return this.formPlanAccion.controls;
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  //////////////////////////Para el árbol de unidades //////////////////////////
  getTreeUnidadesSiipne() {
    this.unidadesSiipneService.listParents().subscribe((resp: TreeNode[]) => {

      this.unidades = resp;
      this.unidades.forEach(node => {
        this.unidadesSiipneService.listChilds(node.data).subscribe((respChild: TreeNode[]) => {
          node.children = respChild;
        });
      });
    });
  }

  nodeSelect(evt) {
   
    this.nombreRuta = (this.nombreRuta) + (" / " + evt.node.label),
      this.formPlanAccion.patchValue({
        idDgpUnidad: evt.node.data,
        localidadImpacto: this.nombreRuta
      });
  }

  nodeExpand(event) {
    if (event.node) {
      this.unidadesSiipneService.listChilds(event.node.data).subscribe(resp => {
        event.node.children = resp;
      });
    }
  }

  //////////////////////////FIN árbol de unidades //////////////////////////
  listRiesgos() {
    this.riesgosService.list().subscribe(
      resp => {
        this.dataRiesgos = resp;
      }
    )
  }

  totalRiesgos(id: number, dataRiesgos: any[]) {
    return dataRiesgos?.filter((resp) => {
      return resp.idSprPlanAccion === id;
    }
    );
  }

  /**
     * metodo totalActividades() retorna numero total de actividades por cada linea de acción
     */
  listActividades() {
    this.actividadesService.list().subscribe(
      resp => {
        this.dataActividades = resp;
      }
    )
  }

  totalActividades(id: number, dataActividades: any[]) {
    return dataActividades?.filter((resp) => {
      return resp.idSprPlanAccion === id;
    }
    );
  }
}
